import { useT } from "react-polyglot-hooks"
import * as PropTypes from "prop-types"
import useFilteredOptions from "hooks/useFilteredOptions"
import { applyFilters } from "helpers/filterCars"
import { useContext } from "react"
import { RentingContext } from "scenes/RentingScene/RentingContext"
import Typography from "components/styled/Typography"
import Selector from "../Selector"

const priceRanges = [
  [-1, 250],
  [250, 300],
  [300, 400],
  [400, -1]
]

export default function PriceSelector({ field, value, show, handleChange, label }) {
  const t = useT()
  const { cars } = useContext(RentingContext)

  const getLabel = (min, max) => {
    if (min < 0) return t("renting.filter.price_ranges.less_than", { max })
    if (max < 0) return t("renting.filter.price_ranges.more_than", { min })

    return t("renting.filter.price_ranges.between", { min, max })
  }

  const options = useFilteredOptions(field, () =>
    priceRanges
      .map(([min, max]) => ({
        value: `${min}_${max}`,
        label: getLabel(min, max)
      }))
      .filter(option => applyFilters(cars, { [field]: option.value }).length > 0)
  )

  if (!show) return null

  return (
    <>
      {label && (
        <Typography el="label" className="mb-2">
          {label}
        </Typography>
      )}
      <Selector
        field={field}
        initialValue={value}
        options={options}
        handleChange={handleChange}
        multiple
        col={{ xs: 3, lg: 6 }}
      />
    </>
  )
}

PriceSelector.defaultProps = { show: true, label: null, field: "priceRanges", value: [] }

PriceSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  show: PropTypes.bool,
  label: PropTypes.string,
  field: PropTypes.string,
  handleChange: PropTypes.func.isRequired
}
